module.exports = __webpack_public_path__ + "img/ug.46b347fb.png";